import React from "react";
import { connect } from "react-redux";
import { langCheck, isInsideTab, queryRecentVisit } from "Pub/js/utils";
import { Popover } from "antd";
import Ajax from "Pub/js/ajax";
import { setRecent } from "Store/appStore/action";
import { ControlTip } from "Components/ControlTip";
import { RECENTVISIT } from "Pub/js/allApps";
import CollectTooltip from 'Components/CollectTooltip';
import defaultIcon from "Pub/js/defaultIcon";
import platform from "Pub/js/platform";
import noviceGuideRecentvisit from "Assets/images/noviceGuide/novice-guide-recentvisit.png";
import { getStore } from "Pub/js/storageUtils";
import _ from "lodash";
const { base, appIcons } = platform;
const { NCTooltip } = base;
import noVisit from 'Assets/images/no-visit.png';
class RecentVisit extends React.Component {
    constructor(props) {
        super(props);
        this.state = { visible: false };
    }
    // componentDidMount() {
    //     this.getRecentData();
    // }
    componentWillUnmount() {
        window.removeEventListener("click", this.messageClick);
    }
    // 解决iframe下点击 弹窗不关闭
    messageClick = () => {
        let { visible } = this.state;
        let that = this;
        let ifr = document.getElementById("mainiframe");
        if (ifr) {
            ifr.contentDocument.onclick = function () {
                if (visible) {
                    that.handlePopClose();
                }
            };
        }
    };
    // 查询最近访问
    getRecentData = () => {
        queryRecentVisit().then(result => {
            this.props.setRecent(result);
            PubSub.publish(RECENTVISIT, result);
        });
    };
    // 清空最近访问
    clearRecent = () => {
        ControlTip({
            status: "warning",
            title: langCheck("0000PUB-000311"),
            msg: langCheck("0000PUB-000281") /* 国际化处理： 确定要清空最近访问?*/,
            onOk: () => {
                Ajax({
                    url: "/nccloud/platform/appregister/deleterecentvisit.do",
                    data: {},
                    info: {
                        name: langCheck("0000PUB-000276") /* 国际化处理： 最近访问*/,
                        action: langCheck("0000PUB-000314"), /* 国际化处理： 清空最近访问*/
                    },
                    success: ({ data }) => {
                        if (data.success) {
                            this.setState({ visible: false });
                        }
                    },
                    error: error => {
                        console.log(error);
                    },
                });
            },
        });
    };
    handleVisibleChange = flag => {
        if (flag) {
            this.getRecentData();
        }
        // if (flag) {
        //     this.props.onAllAppClick(false);
        //     window.addEventListener("click", this.messageClick);
        //     this.resetScrollPosition(); //恢复滚动条位置
        //     await this.getRecentData();
        // } else {
        //     window.removeEventListener("click", this.messageClick);
        // }
        // this.setState({ visible: flag });
    };
    // handlePopChange = () => {
    //     let { visible } = this.state;
    //     if (!visible) {
    //         this.props.onAllAppClick(false);
    //         this.resetScrollPosition(); //恢复滚动条位置
    //         this.getRecentData();
    //     }
    //     this.setState({ visible: !visible });
    // }
    handlePopClose = e => {
        this.setState({ visible: false });
    }
    /**
     * 处理已访问应用列表的点击事件
     * @param {Object} e 事件对象
     */
    onItemListClick = e => {
        let { recentData } = this.props;
        let target = e.target;
        if (!target.classList.contains('app-open') && !target.classList.contains('item-app')) {
            target = target.parentElement;
        }
        let openType = target.getAttribute('open-type');
        let itemIdx = target.getAttribute('item-index');
        let itemData;

        if (!openType) { return true; }
        itemData = _.result(recentData, `[${itemIdx}]`);
        if (itemData) {
            if (itemData.code) {
                itemData.menuitemcode = itemData.code; //传菜单编码
            }
            window.openNew(itemData, null, null, { openTabWithoutCheck: openType === 'newtab' });
        }
        isInsideTab() && this.handlePopClose(); // 内部页签打开需要关闭弹窗
    }
    //恢复滚动条位置
    resetScrollPosition = () => {
        setTimeout(() => {
            if (this.contentRef) { this.contentRef.scrollTop = 0; }
        }, 0);
    }
    // 修改收藏状态
    setNewContentData = contentData => {
        this.props.setRecent(contentData);
    }
    // 暂无访问数据
    renderNoVisit = () => {
        return <p
            className='no-visit'
        ><img src={noVisit} alt="" />{langCheck("0000PUB-000478") /** 暂无访问记录 */}</p>;
    }
    // 渲染标题
    renderTitle = () => {
        let { recentData } = this.props;
        return <React.Fragment>
            <p>{langCheck("0000PUB-000276")}</p>
        </React.Fragment>;
    }
    render() {
        let { recentData, className, onInsideNav } = this.props;
        const { visible } = this.state;
        const flag = recentData && recentData.length;
        const container = (
            <div
                style={flag ? { paddingBottom: '8px', position: 'relative' } : { position: 'relative' }}
                onClick={e => {
                    if (!flag) {
                        e.stopPropagation();
                    }
                }}
            >
                <div className='recentVisit' onClick={e => {
                    e.stopPropagation();
                    this.onItemListClick(e);
                }} ref={ref => this.contentRef = ref}>
                    {recentData &&
                        recentData.map((item, index) => {
                            let iconType = getStore("nccIcon") || "";
                            iconType = iconType.length ? iconType + "_" : iconType;
                            return (
                                <div key={`wrap_${index}`} className='item-app' open-type="tab" item-index={index}>
                                    {/* <img src={item.image_src && appIcons[item.image_src] ? appIcons[item.image_src] : defaultIcon["defaultIcon"]}/> */}
                                    <img src={
                                        appIcons && appIcons[iconType + item.image_src]
                                            ? appIcons[iconType + item.image_src]
                                            : defaultIcon[iconType]
                                                ? defaultIcon[iconType]
                                                : defaultIcon['defaultIcon']
                                    } />
                                    <a
                                        key={index}
                                        // href='javascript:void(0);'
                                        className="app-label"
                                        item-index={index}
                                        open-type="tab"
                                    // onClick={() => {
                                    //         window.openNew(item);
                                    // }}
                                    >
                                        {item.label}
                                    </a>
                                    <NCTooltip
                                        placement='top'
                                        overlay={langCheck('0000PUB-000372')}
                                        trigger='hover'
                                        delayShow={500}
                                        delay={1}
                                        mouseLeaveDelay={0}
                                        getPopupContainer={() => document.body}
                                    >
                                        <i
                                            className="iconfont icon-xinyeqiandakai app-open"
                                            item-index={index}
                                            open-type="newtab"
                                        />
                                    </NCTooltip>
                                    <CollectTooltip
                                        key={item.appcode}
                                        itemData={item}
                                        contentData={recentData}
                                        setNewContentData={this.setNewContentData}
                                    />
                                </div>
                            );
                        })}
                </div>
                {flag ? '' : this.renderNoVisit()}
                {
                    flag ? <span className='recentClear nc-theme-link-font-c' onClick={e => { e.stopPropagation(); this.clearRecent(); }}>
                        {/* <i className='iconfont icon-shanchu' /> */}
                        {langCheck("0000PUB-000311")}
                    </span> : ''
                }
            </div>
        );
        const dataIntro = `<p>${langCheck("0000PUB-000342")}</p>
                            <div class='span-box'>
                            <span>${langCheck("0000PUB-000343")}</span>
                            </div>
                            <img src=${noviceGuideRecentvisit} alt="" class='novice-guide-recentvisit' />`;

        const antPopoverTitle = document.querySelector('.ant-popover-title');
        if (antPopoverTitle) {
            // 点击标题时不让打开应用菜单
            antPopoverTitle.addEventListener('click', e => {
                e.stopPropagation();
            });
        }
        return (
            <div
                className={`nc-workbenchRecent`}
            >
                    <Popover
                        overlayClassName={`recentVisit-popup ${onInsideNav ? 'on-inside-nav' : 'on-workbench-nav'}`}
                        trigger='hover'
                        placement='bottomLeft'
                        content={container}
                        title={this.renderTitle()}
                        // visible={true}
                        onVisibleChange={this.handleVisibleChange}
                        arrowPointAtCenter
                        destroyTooltipOnHide
                        getPopupContainer={() => document.querySelector(onInsideNav ? ".inside-tabs-nav" : ".nc-workbench-nav")}
                    // onClick={(e) => { e.stopPropagation() }}
                    // getPopupContainer={trigger => trigger.querySelector('.iconContainer > i')}
                    >
                        {/* <div tabIndex="-1"  className='iconContainer'> */}
                        {this.props.children}
                        {/* {
                                !visible ?
                                    <NCTooltip
                                        placement='bottom'
                                        overlay={langCheck("0000PUB-000276")}
                                        trigger='hover'
                                        delayShow={500}
                                        delay={1}
                                        mouseLeaveDelay={0}
                                    >
                                        <i className='iconfont icon-zuijinfangwen' />
                                    </NCTooltip> :
                                    <i className='iconfont icon-zuijinfangwen' />
                            } */}
                        {/* </div> */}
                    </Popover>
            </div>
        );
    }
}
export default connect(
    state => ({ recentData: state.appData.recentData }),
    { setRecent },
)(RecentVisit);
